import { render, staticRenderFns } from "./PasswordResetSuccessCard.vue?vue&type=template&id=638da7d4"
import script from "./PasswordResetSuccessCard.vue?vue&type=script&lang=js"
export * from "./PasswordResetSuccessCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports